import React from "react";
import { Link } from "react-router-dom";
import BookNow from "../../components/BookNow";
import SectionTitle from "../../components/SectionTitle";
import icon2 from "./img/bamboo-icon.png";
import img2 from "./img/bamboo.png";
import icon3 from "./img/bff-icon.png";
import img3 from "./img/bff.png";
import icon4 from "./img/chicken-icon.png";
import img4 from "./img/chicken.png";
import icon6 from "./img/pizza-icon.png";
import img6 from "./img/pizza.png";
import shapes from "./img/shapes.png";
import icon5 from "./img/subs-zone-icon.png";
import img5 from "./img/subszone.png";
import icon1 from "./img/wings-icon.png";
import img1 from "./img/wings.png";
import img7 from "./img/NYPD_Pasta.png";
import icon7 from "./img/pasta-icon.png";

const data = [
	{
		img: img1,
		title: "Just Chicken Wings",
		subtitle: "Crispy Chicken Wings & Boneless Bites",
		text: [
			"Perfect for quick-service restaurants, bars, and high-traffic locations.",
			"Crispy, juicy wings and boneless bites served with six signature sauces.",
			"Simple menu with high demand, low food costs, and strong profitability.",
		],
		icon: icon1,
		link: "/brands/just-chicken-wings",
	},
	{
		img: img2,
		title: "The Imperial Bamboo",
		subtitle: "Authentic Chinese Cuisine with a Modern Twist",
		text: [
			"Ideal for Asian restaurants, fusion concepts, and fast-casual dining.",
			"A fusion of traditional Chinese flavors with an American touch.",
			"High-ticket menu with strong profitability and customer appeal.",
		],
		icon: icon2,
		link: "/brands/the-imperial-bamboo",
	},
	{
		img: img3,
		title: "BFF",
		subtitle: "Gourmet Burgers & French Fries",
		text: [
			"Perfect for diners, fast-casual restaurants, and high-volume takeout spots.",
			"Burgers & fries are always in demand, with low operational complexity.",
			"Seven unique burger creations designed for speed and customer satisfaction.",
		],
		icon: icon3,
		link: "/brands/bff",
	},
	{
		img: img4,
		title: "Crazy Tasty Chicken",
		subtitle: "Tenders, Thighs & Breast Fried Chicken",
		text: [
			"Designed for gas stations, convenience stores, and high-speed locations.",
			"Bold, crispy, and flavorful chicken made with a proprietary seasoning blend.",
			"High-margin, easy-to-execute menu designed for fast food success.",
		],
		icon: icon4,
		link: "/brands/crazy-tasty-chicken",
	},
	{
		img: img6,
		title: "NYPD Pizza",
		subtitle: "Authentic New York-Style Pizza",
		text: [
			"Ideal for pizzerias, casual dining, and delivery-focused restaurants.",
			"Hand-stretched dough, premium cheese, and signature flavors.",
			"Consistently high demand with multiple upselling opportunities.",
		],
		icon: icon6,
		link: "/brands/nypd-pizza",
	},
	{
		img: img7,
		title: "NYPD Pasta",
		subtitle: "New York-Inspired Pasta Creations",
		text: [
			"Designed for Italian restaurants, pizzerias, and casual dining locations.",
			"Rich, flavorful pasta dishes with easy execution and high profitability.",
			"Works well as a profitable menu add-on with low operational effort.",
		],
		icon: icon7,
		link: "/brands/nypd-pasta",
	},
	{
		img: img5,
		title: "Sub’s Zone",
		subtitle: "Fresh, Customizable Hot & Cold Subs",
		text: [
			"Perfect for sandwich shops, delis, and convenience stores.",
			"Customers can personalize their hoagies with fresh meats, cheeses, and toppings.",
			"High-speed service with minimal equipment requirements.",
		],
		icon: icon5,
		link: "/brands/subs-zone",
	},
	
];


const Brands = () => {
	return (
		<>
			<section className="section-gap brands-inner-section">
				{data?.map(({ img, title, subtitle, text, icon, link }, i) => (
					<section
						className="position-relative overflow-hidden section-gap"
						key={i}
					>
						<img
							src={shapes}
							className={`shape ${i % 2 === 0 ? "odd" : ""}`}
							alt=""
						/>
						<div className="container">
							<div
								className={`row g-4 ${i % 2 === 0 ? "flex-row-reverse" : ""
									}`}
							>
								<div className="col-lg-6 text-center">
									<img
										src={img}
										alt={title}
										className="mw-100 mt-lg-5"
									/>
								</div>
								<div className="col-lg-6">
									<SectionTitle shapeColor title={title} text={subtitle} />
									<div className="text-contents">
										{text?.map((item, j) => (
											<p key={j}>{item}</p>
										))}
									</div>
									{icon && (
										<img src={icon} className="pt-3 mw-100" alt={title} />
									)}
									{/* Learn More Button with Existing Header Style */}
									<div className="mt-3">
									<Link className="cmn-btn " to={link} >
									<span>LEARN MORE</span>
									</Link>
									</div>
								</div>
							</div>
						</div>
					</section>
				))}
			</section>
			<BookNow />
		</>
	);
};

export default Brands;

